import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

const converter = {
  toFirestore(doc: Partial<UserUiState.Doc>): firebase.firestore.DocumentData {
    return withoutNulls(doc);
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): UserUiState.Doc {
    return snapshot.data(options) as UserUiState.Doc;
  },
};

// A user's own UI state, outside any account (see UserUiState.Doc)
const getUserUiStateRef = ({
  userId,
  db,
}: {
  userId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection(STORE_CONSTANTS.USER_UI_STATE_COLLECTION)
    .doc(userId)
    .withConverter(converter);
};

export default getUserUiStateRef;
